import { hasCapability, type User } from "../base";

export const escalation = {
  manage: (user: User) => hasCapability(user, "escalation.manage"),
};
